import * as tg from "generic-type-guard";

export const isEnvironmentData = new tg.IsInterface()
	.withOptionalProperties({
		currentEnvName: tg.isString,
		postfach: new tg.IsInterface()
			.withOptionalProperties({
				maxFiles: tg.isNumber,
				allowedExtensions: tg.isArray(tg.isString),
				allowedSizeMb: tg.isDouble
			})
			.get(),
		documentsUrl: tg.isString
	})
	.get();

export type EnvironmentData = tg.GuardedType<typeof isEnvironmentData>;
